import type { FeatureBlockContent, HeroContent } from '../types';
import {
  businessHero as businessHeroEn,
  businessInvoices as businessInvoicesEn,
  businessPayTeam as businessPayTeamEn,
  businessReceive as businessReceiveEn,
} from '../business';
import {
  accountsConvert as accountsConvertAr,
  accountsReceive as accountsReceiveAr,
} from './accounts';

/**
 * Arabic business page copy, from section 13 of the nsave Arabic Localization Pack.
 *
 * ⚠️ Section 13 of the pack requires card availability, payroll availability, the
 * supported markets and the "best rate" phrasing to be reviewed by Product and
 * Compliance before this page is published. The copy below deliberately avoids the
 * unqualified "best rate" superlative for that reason (checklist item 4).
 *
 * The receive and convert row copy is shared with the Arabic homepage rather than
 * retranslated — the English source strings are identical, so a divergence here
 * would be a bug, not a nuance. Only the icons differ, and those come from the
 * English content via the spread.
 */

export const businessHero: HeroContent = {
  ...businessHeroEn,
  title: 'المنصة الواحدة لكل أعمالك الدولية',
  cta: { ...businessHeroEn.cta, label: 'سجّل شركتك' },
  secondaryCta: { ...businessHeroEn.secondaryCta!, label: 'سجّل الدخول' },
  image: {
    ...businessHeroEn.image,
    alt: 'لوحة تحكم nsave للشركات وبتعرض رصيد بالدولار والمعاملات على شاشة مكتب',
  },
};

export const businessReceive: FeatureBlockContent = {
  ...businessReceiveEn,
  title: 'استقبل مدفوعاتك الدولية',
  image: {
    ...businessReceiveEn.image,
    alt: 'حساب nsave متعدد العملات وبيعرض أرصدة بالدولار والإسترليني واليورو',
  },
  // Same three transfer rows as the homepage, with the business icons kept.
  rows: businessReceiveEn.rows.map((row, i) => ({
    ...row,
    title: accountsReceiveAr.rows[i].title,
    description: accountsReceiveAr.rows[i].description,
  })),
};

export const businessInvoices: FeatureBlockContent = {
  ...businessInvoicesEn,
  title: 'ادفع فواتيرك',
  image: {
    ...businessInvoicesEn.image,
    alt: 'نوتة حمرا على ورق مربعات وقلم، جاهزين لتسجيل الفواتير والحسابات',
  },
  rows: businessInvoicesEn.rows.map((row, i) => ({
    ...row,
    title: accountsConvertAr.rows[i].title,
    description: accountsConvertAr.rows[i].description,
  })),
};

export const businessPayTeam: FeatureBlockContent = {
  ...businessPayTeamEn,
  title: 'ادفع لفريقك',
  image: {
    ...businessPayTeamEn.image,
    alt: 'شخص بيشتغل على الكمبيوتر وبيدير رواتب فريقه',
  },
  rows: [
    {
      ...businessPayTeamEn.rows[0],
      title: 'شغّل الرواتب',
      description: 'ادفع لفريقك، سواء على حساباتهم البنكية المحلية أو حساباتهم على nsave.',
    },
    {
      ...businessPayTeamEn.rows[1],
      title: 'حوّل لحسابات فريقك على nsave',
      description: 'سجّل فريقك العالمي على nsave وادفع لهم بسهولة من غير رسوم باستخدام @ntag.',
    },
  ],
};
